import moment from "moment";

const CATS = [
  {
    title: "Saves",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "saves")?.value;
    },
  },
  {
    title: "Goals prevented",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "blockedScoringAtt")?.value;
    },
  },
  {
    title: "Throws",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "keeperThrows")?.value;
    },
  },
  {
    title: "Punches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "punches")?.value;
    },
  },
  {
    title: "Accurate passes",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "accuratePass")?.value;
    },
  },
  {
    title: "Touches",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touches")?.value;
    },
  },
  {
    title: "Clearances",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalClearance")?.value;
    },
  },
  {
    title: "Tackles won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wonTackle")?.value;
    },
  },
  {
    title: "Ground duels won",
    calc: ({ stats }) => {
      return (
        stats?.find((s) => s?.type === "duelWon")?.value -
        stats?.find((s) => s?.type === "aerialWon")?.value
      );
    },
  },
  {
    title: "Aerial duels won",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "aerialWon")?.value;
    },
  },
  {
    title: "Fouls committed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "fouls")?.value;
    },
  },
  {
    title: "Chances created",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalAttAssist")?.value;
    },
  },
  {
    title: "Dispossessed",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "dispossessed")?.value;
    },
  },
  {
    title: "Fouled",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "wasFouled")?.value;
    },
  },
  {
    title: "xG",
    calc: ({ stats }) => {
      return "";
    },
  },
  {
    title: "Shots",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalScoringAtt")?.value;
    },
  },
  {
    title: "Shots on target",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "ontargetScoringAtt")?.value;
    },
  },
  {
    title: "Touches in Opp box",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "touchesInOppBox")?.value;
    },
  },
  {
    title: "Offsides",
    calc: ({ stats }) => {
      return stats?.find((s) => s?.type === "totalOffside")?.value;
    },
  },
];

export class PlayerStats {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "PlayerStats";
    this.cb_scene = "Player Stats";
    this.ff_scene = "FF Player Stats";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    if (options.full_frame) {
      this.scene = this.ff_scene;
    } else {
      this.scene = this.cb_scene;
    }
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Title",
      value: {
        text: options.player.title || "",
      },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text:
          options.player.shirt_number ?? options.player.opta_shirt_number ?? "",
      },
    });

    this.data.push({
      name: "Position",
      value: {
        text: options.player?.squad?.position ?? "",
      },
    });
    this.data.push({
      name: "First Name",
      value: {
        text: options.player.first_name ?? options.player.opta_first_name ?? "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player.last_name ?? options.player.opta_last_name ?? "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text:
          options.player.first_name_upper ??
          options.player.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text:
          options.player.last_name_upper ??
          options.player.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player.first_name ?? options.player.opta_first_name ?? "") +
          " " +
          (options.player.last_name ?? options.player.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player.first_name_upper ??
            options.player.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (options.player.last_name_upper ??
            options.player.opta_last_name?.toUpperCase() ??
            ""),
      },
    });
    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Goal Time",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
      this.buildStats({
        stats: options?.game?.opta_player_stats?.home?.find(
          (p) => p?.player === options?.player?.opta_ID
        ),
      });
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
      this.buildStats({
        stats: options?.game?.opta_player_stats?.away?.find(
          (p) => p?.player === options?.player?.opta_ID
        ),
      });
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  buildStats({ team, stats, options }) {
    CATS.map((cat) => {
      this.data.push({
        name: cat.title,
        value: {
          text: cat?.calc({ stats: stats.stats }) || 0,
        },
      });
    });
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
